module.exports = window.__LUVITCONFIG || {};
